/**
 * Display-config registry: found by `schema_class` first, then by docType route
 * (spec §10). A config only overrides — anything it doesn't mention still
 * renders through the shape builder.
 */
import budgetConfig from "./budget";
import idReviewConfig from "./idReview";
import backgroundConfig from "./backgroundReview";
import noteConfig from "./noteReview";
import sizerConfig from "./sizer";

export const ALL_CONFIGS = [budgetConfig, idReviewConfig, backgroundConfig, noteConfig, sizerConfig];

export const buildConfigRegistry = (configs = ALL_CONFIGS) => {
  const bySchema = {};
  const byRoute = {};
  configs.forEach((c) => {
    (c.schemas || []).forEach((s) => (bySchema[s] = c));
    (c.routes || []).forEach((r) => (byRoute[r] = c));
  });
  return { bySchema, byRoute };
};

export const DEFAULT_CONFIGS = buildConfigRegistry();
